import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { CopyService } from 'src/app/services/copy.service';
import { DateUtilityServiceService } from 'src/app/services/date-utility-service.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { VariablesService } from 'src/app/services/variables.service';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
    templateUrl: './hotel.component.html',
    styleUrls: ['./hotel.component.scss'],
    standalone: false
})
export class HotelComponent implements OnInit {


  constructor(private navigationService: NavigationService,
    private copyService: CopyService,
    private registrationService: RegistrationService,
    private dateService: DateUtilityServiceService,
    private variablesService: VariablesService,
    private configurationService: ConfigurationService
) {
  this.enrollment = this.registrationService.getEnrollment({});
  this.attendee = this.registrationService.getAttendee({});
  this.accepRom = registrationService.getVariable(this.attendee, variablesService.VARIABLE.accepRom.ID, {});
  this.respHotel = registrationService.getVariable(this.attendee, variablesService.VARIABLE.respHotel.ID, {});
  this.declineRadios = [
    {
      value: 'Business Conflict',
      display: this.copyService.getCopyByKey(
        'copy.label.INVITATION.declineReason1'
      )
    },
    {
      value: 'Personal Conflict',
      display: this.copyService.getCopyByKey(
        'copy.label.INVITATION.declineReason2'
      )
    },
    {
      value: 'other',
      display: this.copyService.getCopyByKey(
        'copy.label.INVITATION.declineReason3'
      )
    }
  ];

}
  accepRom;
  respHotel;
  $mtcrespHotel;
  enrollment;
  attendee;
  declineRadios;
  isSubmitting;
  HoldSpecialRequests;
  isFormCompleted=false;
  noHotelRadios = [
    { display: "Staying at local residence", value: "Staying at local residence" },
  //  { display: "Sharing a room reserved by someone else", value: "Sharing a room reserved by someone else" },
    { display: "Arranged my own accommodations", value: "Arranged my own accommodations" }
  //  { display: "I will add my hotel later", value: "I will add my hotel later" }
  ];

  caseA=this.copyService.getCopyByKey('copy.html.hotelCustomText');
  CaseB=this.copyService.getCopyByKey('copy.html.hotelCustomText_short');;
  programInfo;

  ngOnInit(): void {
    /*this.configurationService.fetchConfig().then((data: any) => {
      this.programInfo = data;
      this.caseA= data.copy.html.hotelCustomText;
      this.CaseB= data.copy.html.hotelCustomText_short;
    });*/
  }

  getTextToShow(){
    let text;
    if(
      this.attendee.PAXTypeNo ===2 || this.attendee.PAXTypeNo === 5  || this.attendee.PAXTypeNo === 6 
      || (this.attendee.PAXTypeNo ===4 && this.enrollment.HotelNeeded===true && this.accepRom.Value === 'No' )
    ) text= this.caseA;

    if(
      this.attendee.PAXTypeNo ===1 || this.attendee.PAXTypeNo ===3 || this.attendee.PAXTypeNo ===7
      || (this.attendee.PAXTypeNo ===4 && this.enrollment.HotelNeeded===true && this.accepRom.Value === 'Yes')
    ) text= this.CaseB;

    return text;
  }

  clearRequests() {
    if (this.enrollment.HotelNeeded === true) {
      if (this.enrollment.HotelSpecialRequests === "Staying at local residence" || this.enrollment.HotelSpecialRequests === "Sharing a room reserved by someone else"
        || this.enrollment.HotelSpecialRequests === "Arranged my own accommodations" || this.enrollment.HotelSpecialRequests === "I will add my hotel later") {
        this.HoldSpecialRequests = this.enrollment.HotelSpecialRequests;
        this.enrollment.HotelSpecialRequests = "";
      }
    } else if (this.HoldSpecialRequests) {
      this.enrollment.HotelSpecialRequests = this.HoldSpecialRequests;
    }
    if(this.attendee.PAXTypeNo === 4 && this.enrollment.HotelNeeded === false){ console.log('change resphotel');
      if(this.respHotel != undefined && this.respHotel.Value != undefined){
         this.respHotel.Value= '';
      }
    }
  }

  changeAcceptRoom(){
     if(this.accepRom !==undefined && this.accepRom.Value==='Yes'){
      if(this.respHotel != undefined && this.respHotel.Value != undefined){
         this.respHotel.Value= '';
      }
    } 
  }
  forward(form) {
    this.isFormCompleted=true;
    if (this.enrollment.HotelNeeded !== undefined && form.valid) {
      if (this.enrollment.HotelNeeded) {
        // User must have selected hotels on contiguous dates
          this.isSubmitting = true;
          this.navigationService.forward();
      } else {

        this.isSubmitting = true;
        this.navigationService.forward();
      }
       this.respHotel.Value= this.enrollment.$mtcRespHotel?"Yes":"";
    } else {
      this.isSubmitting = false;
    }
  }

  back() {
    this.navigationService.back();
  }

}
